//
// Get media types (source : laravel config/mediatypes.php
const configAwsParameters = window.config.awsParameters

export default Object.freeze(configAwsParameters)
